import { render, staticRenderFns } from "./WorkspaceEditPage.vue?vue&type=template&id=a8d0d584&"
import script from "./WorkspaceEditPage.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceEditPage.vue?vue&type=style&index=0&id=a8d0d584&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports